import { Box, CircularProgress } from "@mui/material";

export default function Loader ({vh}){
    return (
        <Box sx={{height: `${vh}vh`, width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
            <CircularProgress />
        </Box>
    );
}